import React from 'react';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { API_PLATFORM_VERSIONS } from '../constants';
import EditPlatformVersionModal from './EditPlatformVersionModal';

type Props = {
  open: boolean;
  onClose: ModalCloseHandler;
};

function AddPlatformVersionModalContainer({ open, onClose }: Props) {
  const { showAlert } = useAlert();
  const [handleSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: API_PLATFORM_VERSIONS,
        useProxy: false,
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'Platform version added',
        text: 'Platform version has been successfully added.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <EditPlatformVersionModal
      title="Add platform version"
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      loading={loading}
    />
  );
}

export default AddPlatformVersionModalContainer;
